export default [
  ['\\|1', 'a'],
  ['\\|2', 'b'],
  ['\\|3', 'c'],
  ['\\|4', 'd'],
  ['\\|5', 'e'],
  ['\\|6', 'f'],
  ['\\|7', 'g'],
  ['\\|8', 'h'],
  ['\\|9', 'i'],
  ['\\|0', 'j'],
  [',1', 'k'],
  [',2', 'l'],
  [',3', 'm'],
  [',4', 'n'],
  [',5', 'o'],
  [',6', 'p'],
  [',7', 'q'],
  [',8', 'r'],
  [',9', 's'],
  [',0', 't'],
  [',-', 'u'],
];
